import { render, staticRenderFns } from "./footer-link.vue?vue&type=template&id=548da26a&scoped=true&"
import script from "./footer-link.vue?vue&type=script&lang=js&"
export * from "./footer-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548da26a",
  null
  
)

export default component.exports